import {DataObjectId, Hub} from 'yougile-model'

export const getOldestHub = (hubs: Hub[] = []): DataObjectId | undefined => {
  const oldest = hubs.reduce((acc, curr) => {
    if (!curr) {
      return acc
    }

    const accTs = acc?.timestamp || Number.MAX_SAFE_INTEGER
    if (curr.timestamp < accTs) {
      return curr
    }

    return acc
  }, hubs[0])

  return oldest?.id
}
